import { cn } from "../../lib/utils";
import { useChartTooltipRowContext } from "./ChartTooltipContext";

export interface ChartTooltipNameProps {
  className?: string;
}

/** A row's series name, resolved from the surrounding Chart config. */
export const ChartTooltipName = ({ className }: ChartTooltipNameProps) => {
  const { name } = useChartTooltipRowContext();
  return (
    <span data-slot="chart-tooltip-name" className={cn("text-muted-foreground", className)}>
      {name}
    </span>
  );
};
